<template>
	<div class="window_construction_images " :class="{'window_and_door': windowAndDoorImgs() }" >
    <img v-if="images.left_door_img"  :src="getImgURL(images.left_door_img)"  class="door_img"  />
    <img v-if="images.window_img"     :src="getImgURL(images.window_img)"     class="window_img"/>
    <img v-if="images.rigth_door_img" :src="getImgURL(images.rigth_door_img)" class="door_img"  />
	</div>
</template>
<script>

import { mapState } from "vuex";

export default {
  name: "WindowConstructionImg",
  props: ["images"],
  methods: {
    windowAndDoorImgs() {
      return this.images.window_img && (this.images.left_door_img || this.images.rigth_door_img)
    }
  }
};
</script>
<style type="text/css" scoped>
  .window_construction_images {
    display: flex;
    height: 90px;
    width: 90px;
  }
  .door_img {
    width: 100%;
    height: 100%;
  }
  .window_and_door .window_img {
    height: 60%;
  }
  .window_img {
    width: 100%;
    height: 100%;
  }
  img {
    box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
  }
</style>

<script setup>

import getImgURL from '../../composables/getImgUrl.js'

</script>
